import { TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';

import { usePaymentAttemptsTable } from '@/components/modules/PaymentAttempts/shared/hooks/usePaymentAttemptsTable';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const PaymentAttemptsTableHeader: React.FC = () => {
  const { classes, columns } = usePaymentAttemptsTable();

  return (
    <TableHead className={classes.root}>
      <TableRow>
        {columns.map((column) => (
          <TableCell key={column.name} align={column.align} width={column.colWidth ? column.colWidth : 'auto'}>
            <Font variant={'body2'} color={'textSecondary'}>
              <Text tId={column.label} />
            </Font>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
